import React from 'react'
import PropTypes from 'prop-types'

class ChapterDropdown extends React.Component {
  handleChange = e => {
    this.props.handleChange(e.target.value)
  }

  generateOptions = () => {
    let options = this.props.chapterDropdown.map((item, key) => (
      <option value={item['value']} key={key}>
        {item['name']}
      </option>
    ))
    options.unshift(
      <option value="" key={-1}>
        All Content
      </option>
    )
    return options
  }

  render() {
    const options = this.generateOptions(this.props.chapterDropdown)
    return (
      <div className="chapter_filter">
        <div>Compile analytics for</div>
        <select
          id="chapter_filter_select"
          onChange={this.handleChange}
          value={this.props.value}
        >
          {options}
        </select>
      </div>
    )
  }
}

ChapterDropdown.propTypes = {
  chapterDropdown: PropTypes.array.isRequired,
  handleChange: PropTypes.func,
  value: PropTypes.string,
}

export default ChapterDropdown
